import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-community'
import { ExternalServiceApiTokenRow } from '../ExternalServiceApiTokenRow'
import { intl } from '../../../../i18n'
import {
  ContextMenuItemId,
  getMenuIconHtml,
} from '../../../containers/commons/AgGrid/lib/contextMenu'

type RevokeHandler = (row: ExternalServiceApiTokenRow) => void

export const createGetContextMenuItems =
  (onRevoke: RevokeHandler) =>
  (
    params: GetContextMenuItemsParams<ExternalServiceApiTokenRow>
  ): (string | MenuItemDef)[] => {
    const { data } = params.node ?? {}
    if (!data || data.revoked) {
      return []
    }

    return [
      {
        name: intl.formatMessage({
          id: 'externalServiceApiToken.contextMenu.revoke',
        }),
        icon: getMenuIconHtml(ContextMenuItemId.REMOVE_ROW),
        action: () => onRevoke(data),
      },
    ]
  }
